class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverEnabled = this.summary.id === 'HeaderMenu-shop';
    this.lastInteractionWasKeyboard = false;
    this.closeTimer = null;
    this.closeDelay = 350;

    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.summary.addEventListener('keydown', () => (this.lastInteractionWasKeyboard = true));
    this.summary.addEventListener('pointerdown', () => (this.lastInteractionWasKeyboard = false));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onPointerEnter() {
    if (!this.hoverEnabled || !this.hoverMediaQuery.matches) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = null;
    this.open();
  }

  onPointerLeave() {
    if (!this.hoverEnabled || !this.hoverMediaQuery.matches) return;
    if (this.contains(document.activeElement) && this.lastInteractionWasKeyboard) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      if (!this.matches(':hover')) this.close();
    }, this.closeDelay);
  }

  onSummaryClick(event) {
    if (!this.hoverEnabled || !this.hoverMediaQuery.matches || event.detail === 0) return;

    event.preventDefault();
    this.open();
  }

  open() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = null;

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = null;
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
